import type { ThemeClasses } from "../types";

interface DeviceViewToggleProps {
  themeClasses: ThemeClasses;
  selectedView: "grid" | "list";
  onViewChange: (view: "grid" | "list") => void;
}

export function DeviceViewToggle({
  themeClasses,
  selectedView,
  onViewChange,
}: DeviceViewToggleProps) {
  return (
    <div className="ml-auto flex shrink-0">
      <div
        className={`flex ${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-lg p-1`}
      >
        <button
          className={`px-3 py-1 rounded-md transition-colors ${
            selectedView === "grid"
              ? "bg-primary-500 text-gray-900"
              : `${themeClasses.buttonText} ${themeClasses.buttonHover}`
          }`}
          onClick={() => onViewChange("grid")}
        >
          <i className="ri-grid-fill"></i>
        </button>
        <button
          className={`px-3 py-1 rounded-md transition-colors ${
            selectedView === "list"
              ? "bg-primary-500 text-gray-900"
              : `${themeClasses.buttonText} ${themeClasses.buttonHover}`
          }`}
          onClick={() => onViewChange("list")}
        >
          <i className="ri-list-check"></i>
        </button>
      </div>
    </div>
  );
}
